module.exports = __webpack_public_path__ + "static/media/Factory438316_454596305_fullsize.e8c6d9a4.jpg";